<div class="p-4">
  <!-- Error / QZ Tray connection status -->
  <div *ngIf="errorMessage" class="mb-4 p-3 border rounded-md printer-setup-error">
    <div class="flex items-center gap-2">
      <i class="pi pi-exclamation-triangle printer-setup-error-icon"></i>
      <span class="font-semibold printer-setup-error-text">{{ errorMessage }}</span>
    </div>
    <div class="mt-3 text-sm" *ngIf="showLink">
      Download
      <a
        href="https://bak4uniformaxdb.blob.core.windows.net/qztray/qz-tray-2.2.4-SNAPSHOT-x86_64.zip?sp=r&st=2026-05-05T23:17:59Z&se=2050-05-06T07:32:59Z&spr=https&sv=2025-11-05&sr=b&sig=XS9hXWtwDgToUkWlRJRnjb09M1uGx3Ck37B%2FnvKFoPI%3D"
        class="printer-setup-link"
        target="_blank"
        >qz-tray-2.2.4-SNAPSHOT-x86_64.zip</a
      >
      to install QZ Tray.
      <ol class="ml-6 mt-2 list-decimal">
        <li>Download zip file from the link above</li>
        <li>Extract all files from the zip</li>
        <li>Unblock the .exe file: right-click, Properties, check Unblock, click Ok</li>
        <li>Double-click the .exe to start the install</li>
      </ol>
    </div>
  </div>

  <!-- Printer Configuration Card -->
  <div class="qb-detail-card qb-primary-tint p-4 mb-4">
    <div class="font-semibold text-base mb-3 border-b pb-2 uppercase tracking-wide">Printer Configuration</div>

    <div *ngIf="clientPrinters" class="flex flex-col gap-4">
      <uni-field label="Barcode Printer (ZPL only)">
        <p-dropdown [(ngModel)]="barcodePrinter" [options]="clientPrinters" (onChange)="save()" styleClass="w-full" />
      </uni-field>

      <uni-field label="Invoice Printer">
        <p-dropdown [(ngModel)]="invoicePrinter" [options]="clientPrinters" (onChange)="save()" styleClass="w-full" />
      </uni-field>

      <uni-field label="Shipping Label Printer">
        <p-dropdown [(ngModel)]="labelPrinter" [options]="clientPrinters" (onChange)="save()" styleClass="w-full" />
      </uni-field>

      <uni-field label="Shipping Label Format">
        <p-dropdown [(ngModel)]="labelFormat" [options]="labelFormats" (onChange)="save()" styleClass="w-full" />
      </uni-field>
    </div>

    <div *ngIf="!clientPrinters" class="flex items-center gap-2 py-4 printer-setup-hint">
      <i class="pi pi-spinner pi-spin"></i>
      <span>Detecting printers...</span>
    </div>
  </div>

  <!-- Diagnostics Card -->
  <div class="qb-detail-card qb-primary-tint p-4">
    <div class="font-semibold text-base mb-3 border-b pb-2 uppercase tracking-wide">Diagnostics</div>

    <table class="qb-info-table w-full">
      <tr>
        <td class="label printer-setup-label-col">Barcode Printer</td>
        <td class="value">
          <button pButton type="button" class="p-button-outlined p-button-sm" icon="pi pi-print" (click)="testBarcode()">
            <span>Test</span>
          </button>
          <div class="text-sm mt-1 printer-setup-hint">Sends ZPL to barcode printer</div>
        </td>
      </tr>
      <tr>
        <td class="label">Shipping Label</td>
        <td class="value">
          <button pButton type="button" class="p-button-outlined p-button-sm" icon="pi pi-tag" (click)="testShippingLabel()">
            <span>Test</span>
          </button>
          <div class="text-sm mt-1 printer-setup-hint">Downloads from ShipEngine</div>
        </td>
      </tr>
      <tr>
        <td class="label">Email</td>
        <td class="value">
          <button pButton type="button" class="p-button-outlined p-button-sm" icon="pi pi-envelope" (click)="testEmail()">
            <span>Test</span>
          </button>
          <div class="text-sm mt-1 printer-setup-hint">Sends a test email</div>
        </td>
      </tr>
      <tr>
        <td class="label">SMS</td>
        <td class="value">
          <button pButton type="button" class="p-button-outlined p-button-sm" icon="pi pi-mobile" (click)="testSms()">
            <span>Test</span>
          </button>
          <div class="text-sm mt-1 printer-setup-hint">Sends a test SMS</div>
        </td>
      </tr>
      <tr *ngIf="scaleSupported">
        <td class="label">USB Scale</td>
        <td class="value">
          <button pButton type="button" class="p-button-outlined p-button-sm" icon="pi pi-sliders-h" (click)="testScale()">
            <span>Test</span>
          </button>
          <div class="text-sm mt-1 printer-setup-hint">Reads weight from DYMO scale</div>
          <div *ngIf="scaleResult" class="mt-1 text-sm font-semibold">{{ scaleResult }}</div>
        </td>
      </tr>
      <tr>
        <td class="label">SharePoint</td>
        <td class="value">
          <button pButton type="button" class="p-button-outlined p-button-sm" icon="pi pi-cloud-upload" (click)="testSharePoint()">
            <span>Test</span>
          </button>
          <div class="text-sm mt-1 printer-setup-hint">Uploads a test file</div>
        </td>
      </tr>
    </table>
  </div>
</div>
